import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const MarlinsEnglishTestDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsMarlinsEnglishTestDetails" */ 'modules/activityDetails/MarlinsEnglishTestDetails/pages/MarlinsEnglishTestDetails'
    )
)

const MarlinsEnglishTestDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route
        exact
        path={`${routes.root}/:testId/:scheduleId`}
        component={MarlinsEnglishTestDetails}
      />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default MarlinsEnglishTestDetailsRouting
